import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Internet Plans',
        content: 'Choose from a variety of high-speed Internet plans tailored to your needs.',
        paragraphs: [
            'Stay connected with our reliable and high-speed Internet plans. Whether you need Internet for casual browsing, streaming, gaming, or running a business, we have a plan that fits your lifestyle and budget.',
            'Our flexible packages are designed to deliver consistent speeds, minimal downtime, and superior support, so you’re always online when it matters most.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'High-Speed Connectivity',
            'Unlimited Data Options',
            '24/7 Technical Support',
            'Easy Plan Upgrades',
            'No Hidden Fees'
        ],
        procedure: [
            'Plan Consultation',
            'Package Selection',
            'On-Site Installation',
            'Speed Testing & Setup',
            'Ongoing Support & Maintenance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What Internet speeds do you offer?',
                content: 'We offer various speed tiers ranging from basic broadband to ultra-fast fiber-optic connections, depending on your location and usage requirements.'
            },
            {
                id: 2,
                heading: 'Are there any data limits?',
                content: 'Many of our plans include unlimited data. We’ll help you choose a plan that suits your usage habits without unexpected overage charges.'
            },
            {
                id: 3,
                heading: 'Is installation included?',
                content: 'Yes, professional installation is included with all our Internet plans to ensure a smooth and quick setup.'
            },
            {
                id: 4,
                heading: 'Can I upgrade my plan later?',
                content: 'Absolutely. Our plans are designed with flexibility in mind, so you can upgrade or adjust your service at any time.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2, // Replace with actual cable-related image path
        title: 'Cable Packages',
        content: 'Explore our diverse range of cable TV packages with premium channels.',
        paragraphs: [
            'Enjoy endless entertainment with our variety of cable TV packages. From sports and movies to kids’ shows and international channels, we offer something for every viewer.',
            'Choose from basic to premium bundles with access to HD channels, on-demand content, and DVR features that enhance your viewing experience.'
        ],
        gallery: [
            images.service2Gallery1, // Replace with actual gallery images
            images.service2Gallery2
        ],
        features: [
            'HD & 4K Channels',
            'Premium Channel Access',
            'Parental Controls',
            'DVR & On-Demand Options',
            'Flexible Bundles'
        ],
        procedure: [
            'Channel Preference Discussion',
            'Package Selection',
            'Equipment Setup',
            'Channel Activation',
            'User Guidance & Support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I customize my cable package?',
                content: 'Yes, you can mix and match channels or upgrade to premium bundles based on your preferences.'
            },
            {
                id: 2,
                heading: 'Do you offer sports or movie packages?',
                content: 'Absolutely. We offer dedicated sports, movies, and international add-ons with most plans.'
            },
            {
                id: 3,
                heading: 'Is DVR service included?',
                content: 'Many of our cable packages include DVR options so you can record and watch shows at your convenience.'
            },
            {
                id: 4,
                heading: 'Can I bundle cable with Internet?',
                content: 'Yes, we offer affordable bundles combining Internet and cable TV services for more savings.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3, // Replace with actual bundled services image path
        title: 'Bundled Services',
        content: 'Save more with our bundled Internet and cable services for your home.',
        paragraphs: [
            'Combine the power of high-speed Internet and premium cable TV into one convenient and cost-effective package. Our bundled services offer seamless connectivity and endless entertainment under a single bill.',
            'Enjoy the ease of setup, simplified billing, and added value while experiencing top-tier digital services customized to suit your household needs.'
        ],
        gallery: [
            images.service3Gallery1, // Replace with actual gallery images
            images.service3Gallery2
        ],
        features: [
            'High-Speed Internet',
            'Premium TV Channels',
            'Unified Billing',
            'Bundle Discounts',
            'Easy Setup & Support'
        ],
        procedure: [
            'Needs Assessment',
            'Package Customization',
            'Installation Scheduling',
            'Service Setup',
            'Final Testing & Walkthrough'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I customize my bundled plan?',
                content: 'Yes, our bundles are flexible—you can choose your preferred Internet speed and TV channels.'
            },
            {
                id: 2,
                heading: 'Is there a discount for bundling services?',
                content: 'Absolutely. Bundling Internet and cable services provides significant savings compared to individual plans.'
            },
            {
                id: 3,
                heading: 'Will I receive one bill for both services?',
                content: 'Yes, both services will be conveniently combined into a single monthly bill.'
            },
            {
                id: 4,
                heading: 'What if I need help after installation?',
                content: 'Our support team is available 24/7 to assist with any issues or questions regarding your bundled services.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4, // Replace with actual technical support image path
        title: 'Technical Support',
        content: 'Get expert technical assistance for any issues you may encounter.',
        paragraphs: [
            'Our dedicated technical support team is available around the clock to ensure your services run smoothly. From troubleshooting connectivity issues to answering your questions, we provide reliable solutions fast.',
            'Whether it’s Internet, cable, or bundled services, our experts are here to resolve problems efficiently and professionally.'
        ],
        gallery: [
            images.service4Gallery1, // Replace with actual gallery images
            images.service4Gallery2
        ],
        features: [
            '24/7 Availability',
            'Remote Troubleshooting',
            'On-Site Assistance',
            'Friendly Support Team',
            'Comprehensive Solutions'
        ],
        procedure: [
            'Issue Reporting',
            'Problem Diagnosis',
            'Remote Fix or Technician Dispatch',
            'Service Verification',
            'Customer Confirmation'
        ],
        faqs: [
            {
                id: 1,
                heading: 'When is technical support available?',
                content: 'Our technical support team is available 24/7 to assist you with any issues.'
            },
            {
                id: 2,
                heading: 'Can you help remotely?',
                content: 'Yes, many problems can be resolved through remote troubleshooting without needing a technician visit.'
            },
            {
                id: 3,
                heading: 'What if the issue needs on-site help?',
                content: 'If required, we’ll schedule an on-site visit at your convenience to resolve the problem.'
            },
            {
                id: 4,
                heading: 'Do I have to pay for support?',
                content: 'Basic technical support is included with your plan. Charges may apply for specific services or hardware replacements.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5, // Replace with actual customer care image path
        title: 'Customer Care',
        content: 'Reach out to our dedicated team for any inquiries or assistance.',
        paragraphs: [
            'Our friendly customer care team is always ready to help you with any questions, service updates, or concerns you may have. We are committed to providing exceptional support and ensuring your satisfaction at every step.',
            'Whether you need account information, service guidance, or help with billing, we’re just a call or message away.'
        ],
        gallery: [
            images.service5Gallery1, // Replace with actual gallery images
            images.service5Gallery2
        ],
        features: [
            'Prompt Response',
            'Knowledgeable Representatives',
            'Multilingual Support',
            'Account Assistance',
            'Flexible Contact Options'
        ],
        procedure: [
            'Reach Out via Phone, Chat, or Email',
            'Customer Verification',
            'Issue Identification',
            'Quick Resolution or Follow-Up',
            'Feedback Collection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What are your customer care hours?',
                content: 'Our customer care team is available 7 days a week from 8 AM to 10 PM, with extended support for urgent issues.'
            },
            {
                id: 2,
                heading: 'How can I contact customer care?',
                content: 'You can reach us by phone, live chat, email, or through the support section on our website.'
            },
            {
                id: 3,
                heading: 'Can I update my account through customer care?',
                content: 'Yes, our team can help you update your account details, preferences, and service plans.'
            },
            {
                id: 4,
                heading: 'Do you offer multilingual support?',
                content: 'Absolutely. We offer support in multiple languages to better serve our diverse customer base.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6, // Replace with actual home installation image
        title: 'Home Installation',
        content: 'Professional installation of your Internet and cable services at home.',
        paragraphs: [
            'Enjoy hassle-free setup with our expert home installation service. We handle everything from Internet wiring to cable box setup, ensuring you get the best signal and performance from the start.',
            'Our technicians are trained, punctual, and respectful of your space—bringing professional-grade installation right to your doorstep.'
        ],
        gallery: [
            images.service6Gallery1, // Replace with actual gallery images
            images.service6Gallery2
        ],
        features: [
            'Certified Technicians',
            'Neat and Safe Wiring',
            'Optimized Router Placement',
            'Full Device Testing',
            'Quick Turnaround'
        ],
        procedure: [
            'Appointment Scheduling',
            'Arrival and Site Inspection',
            'System Setup',
            'Signal Testing and Optimization',
            'Customer Walkthrough'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How long does a home installation take?',
                content: 'Most home installations are completed within 1–2 hours depending on the complexity of the setup.'
            },
            {
                id: 2,
                heading: 'Do I need to prepare anything before the technician arrives?',
                content: 'Ensure access to power outlets, modems, and any areas where service equipment will be installed.'
            },
            {
                id: 3,
                heading: 'Is there an installation fee?',
                content: 'Standard installation is often included with selected plans, but additional charges may apply for complex setups.'
            },
            {
                id: 4,
                heading: 'Can I reschedule my installation appointment?',
                content: 'Yes, just contact our customer care team at least 24 hours in advance to reschedule.'
            }
        ]
    }

];

export default services;